<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">岗位名称：</span>
        <el-input v-model="posName" :size="size" clearable placeholder="请输入岗位名称"></el-input>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchStationList(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="stationList"
        height="100%">
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="posName" label="工作岗位" width="300" align="center"></el-table-column>
        <el-table-column prop="posDesc" label="工作描述" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog
      class="prop_dialog"
      title="添加岗位职责"
      :visible.sync="asyncStation"
      width="35%">
      <el-form ref="form" :model="formStation" :rules="rulesStation" class="rule_form" label-width="auto">
        <el-form-item label="工作岗位：" prop="posName">
          <el-input v-model="formStation.posName" :size="size" clearable placeholder="请输入工作岗位"></el-input>
        </el-form-item>
        <el-form-item label="岗位描述：" prop="posDesc">
          <el-input 
            v-model="formStation.posDesc" 
            :size="size" 
            clearable 
            type="textarea"
            :autosize="{ minRows: 15 }"
            placeholder="请输入岗位描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncStation = false">取 消</el-button>
        <el-button class="submit_btn" @click="submitInsertForm()"> 提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changeSize, throttle } from '../../plugins/public';
import { buttonPinia } from '../../pinia/index';
  export default {
    data() {
      return {
        size: changeSize(),
        posName: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        stationList: [], // 岗位职责信息
        asyncStation: false, // 弹窗
        formStation: {}, // 表单信息
        rulesStation: {
          posName: [{
            required: true,
            message: '请输入工作岗位',
            trigger: 'blur'
          }],
          posDesc: [{
            required: true,
            message: '请输入职责描述',
            trigger: 'blur'
          }]
        } // 校验规则
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchStationList(true);
    },
    methods: {
      // 查询岗位职责信息列表
      searchStationList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.stationList = [];
        this.$api.Personnerl.SEARCHSTATIONLIST({
          posName: this.posName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.stationList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加岗位职责
      propInsert() {
        this.asyncStation = true;
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formStation);
            this.$api.Personnerl.INSERTSTATIONINFO(params).then((res) => {
              if(res.success) {
                this.asyncStation = false;
                this.searchStationList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 删除岗位职责信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该岗位职责，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Personnerl.DELETESTATIONINFO({posId: row.posId})
        .then(res => {
          if(res.success) {
            this.searchStationList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchStationList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchStationList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncStation(bol) {
        if(!bol) {
          this.formStation = {};
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>